import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getContactsQuery($propertyId: ID!) {
    contactGroups(propertyId:$propertyId) {
      id
      name
      status
      count
      reachableCount
      mmsCount
      mmsReachableCount
      createdAt
    }
  }
`;
